import { useEffect, useState } from 'react';
import { CalBookingProps } from '../RuntimeCalBooking';
import { UrlAction } from '../types';
import { resolveUrlParams } from './utils';

interface UseBookerPropsProps extends CalBookingProps {
    setRescheduleUid: (uid: string) => void;
    setCancelBookingId: (uid: string) => void;
    isBookingDryRun: boolean;
}
interface UseBookerPropsReturn extends CalBookingProps {
    isCancelAction?: boolean;
    isRescheduleAction?: boolean;
    bookingUid?: string;
}

export const useBookerProps = (
    props: UseBookerPropsProps
): UseBookerPropsReturn => {
    const [
        {
            slug: urlSlug,
            action: urlAction,
            teamId: urlTeamId,
            bookingUid,
            username: urlUsername,
            isUrlAction,
        },
    ] = useState(() => resolveUrlParams(props.isBookingDryRun));

    const isCancelAction = urlAction === UrlAction.CANCEL;
    const isRescheduleAction = urlAction === UrlAction.RESCHEDULE;

    useEffect(() => {
        if (bookingUid) {
            if (urlAction === UrlAction.RESCHEDULE) {
                props.setRescheduleUid(bookingUid);
            }
            if (urlAction === UrlAction.CANCEL) {
                props.setCancelBookingId(bookingUid);
            }
        }
    }, []);

    if (isUrlAction) {
        return {
            ...props,
            eventSlug: urlSlug || props.eventSlug,
            teamId: urlTeamId || props.teamId,
            userName: urlUsername || props.userName,
            isCancelAction,
            isRescheduleAction,
            bookingUid,
        };
    }

    return props;
};
